import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {deviceModelsActionTypes, LoadDeviceModelsSuccessAction} from '../actions/device-models';
import {GroupRole} from '../../shared/models/groupe-role';

export interface DeviceModelsState {
  array: GroupRole[];
}

const initialState: DeviceModelsState = {
  array: []
};

export function deviceModelsReducer(state: DeviceModelsState = initialState, action: Action): DeviceModelsState {
  switch (action.type) {
    case deviceModelsActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case deviceModelsActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: DeviceModelsState, action: LoadDeviceModelsSuccessAction): DeviceModelsState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: DeviceModelsState): DeviceModelsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}


export const deviceModelsSelectors = {
  array: (state: DeviceModelsState) => _.get(state, 'array', [])
};
